import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useUser } from "../hooks/useUser";
import Loader from "./Spinner.component";

/**
 * Route guard for the bot-operations pages (/observability, /agent,
 * /bot-trades, /agents). Admins and read-only viewers both pass; plain
 * members get bounced to /login. User management stays behind
 * ProtectedAdmin — this guard deliberately does not cover it.
 */
function ProtectedBotView({ children }) {
  const navigate = useNavigate();

  const { isLoading, canViewBots } = useUser();

  useEffect(
    function () {
      if (!canViewBots && !isLoading) navigate("/login");
    },
    [canViewBots, isLoading, navigate]
  );

  if (isLoading) return <Loader />;

  if (canViewBots) return children;
}

export default ProtectedBotView;
